import { combineReducers } from 'redux'
import transaction from 'state/slices/ui/transaction'
import wallet from 'state/slices/ui/wallet'
import explore from 'state/slices/ui/explore'
import form from 'state/slices/ui/form'

export const ui = combineReducers({ transaction, wallet, explore, form })
